import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { SITE } from "../../content";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[var(--ink)] text-[var(--cream)] pt-20 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="font-display font-bold leading-[0.85] text-[15vw] lg:text-[11rem] tracking-tight">
        Yard <span className="text-[var(--sun)]">Party</span>
        <br />
        <span className="text-stroke [-webkit-text-stroke-color:var(--cream)]">Project.</span>
      </p>
      <div className="mt-14 flex flex-col md:flex-row gap-6 md:items-center justify-between border-t border-white/20 pt-8 text-sm text-zinc-300">
        <div className="flex items-center gap-3">
          <LogoMark className="w-9 h-9" />
          <span>Run by kids, supervised by parents. Serving {SITE.area}.</span>
        </div>
        <div className="flex items-center gap-6">
          <span>© {new Date().getFullYear()} {SITE.name}</span>
          <Link to="/admin" data-testid="footer-admin-link" className="underline underline-offset-4 hover:text-[var(--sun)]">
            Parent login
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
